var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.572 7.63459C12.708 7.63459 12.8213 7.67992 12.912 7.77059C13.0026 7.86125 13.048 7.97459 13.048 8.11059V14.7293C13.048 14.8501 12.9951 14.9559 12.8893 15.0466C12.7986 15.1373 12.6928 15.1826 12.572 15.1826H3.14263C3.02174 15.1826 2.9084 15.1373 2.80263 15.0466C2.71196 14.9559 2.66663 14.8501 2.66663 14.7293V8.11059C2.66663 7.97459 2.71196 7.86125 2.80263 7.77059C2.89329 7.67992 3.00663 7.63459 3.14263 7.63459H3.61863V5.27725C3.67907 4.55192 3.90574 3.88703 4.29863 3.28259C4.69151 2.67814 5.19774 2.20214 5.81729 1.85459C6.45196 1.50703 7.13196 1.33325 7.85729 1.33325C8.59774 1.33325 9.27774 1.50703 9.89729 1.85459C10.532 2.20214 11.0457 2.67814 11.4386 3.28259C11.8315 3.88703 12.0582 4.55192 12.1186 5.27725V7.63459H12.572ZM4.54796 5.27725V7.63459H11.1666V5.27725C11.1666 4.67281 11.0155 4.12125 10.7133 3.62259C10.4262 3.10881 10.0257 2.70836 9.51196 2.42125C9.01329 2.11903 8.46174 1.96792 7.85729 1.96792C7.25285 1.96792 6.69374 2.11903 6.17996 2.42125C5.68129 2.70836 5.28085 3.10881 4.97863 3.62259C4.69151 4.12125 4.54796 4.67281 4.54796 5.27725ZM12.1186 14.2533V8.58659H3.61863V14.2533H12.1186Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.f7b6eabdbbaa4938ac161400daad2d4d.svg";
export { ForwardRef as ReactComponent };